import { sendApiRequest } from '@/api/sendApiRequest';
import { httpMethods } from '@/api';
import { TCompanyCodeInfo } from '@/types';

/** Получить коды компании */
export const getCompanyCode = (email: string) => sendApiRequest<TCompanyCodeInfo[]>({
  method: httpMethods.GET,
  endpoint: '/autocomplete/owning_tenants',
  params: { email },
  withoutAuth: true,
});
